import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";

const initialState = {
  loadCustomerSuccessfully: false,
  customerData: {}
};

export default {
  name: "customer",
  actions: {
    loadCustomer: payload => dispatch({ type: "LOAD_CUSTOMER", payload }),
    fetchCustomer: async function () {
      dispatch({ type: "FETCH_CUSTOMER" });
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/customers/info`,
        {
          credentials: "include",
          method: "GET",
          headers: {
            "content-type": "application/json"
          }
        }
      );
      if (response.ok) {
        const data = await response.json();
        this.loadCustomer(data);
        // Insider Event
        if (window.insider_object) {
          const { customerId, email, optOutEDM } = data.customer;
          const user = {
            gdpr_optin: true,
            custom: {
              pushnami_subscribers_id:
                localStorage.pushnamiSubscriberId || undefined,
              publisher_id: localStorage.Publisher_Id || undefined
            },
            uuid: customerId,
            email: email,
            email_optin: optOutEDM === "Y" ? true : false
          };
          window.insider_object.user = user;
          window.Insider.eventManager.dispatch("init-manager:re-initialize");
        }
      } else {
        window.logApiErrors(
          "r",
          "fetchCustomer",
          response.status,
          response.statusText
        );
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "LOAD_CUSTOMER":
        return {
          ...state,
          loadCustomerSuccessfully: true,
          customerData: action.payload
        };
      default:
        return state;
    }
  }
};
